module.exports = __webpack_public_path__ + "static/media/show4.f1eae354.png";